import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/auth';
import { canManageWarehouse } from '../utils/permissions';


interface PrivateRouteProps {
  children: React.ReactNode;
  warehouseOnly?: boolean;
}

export default function PrivateRoute({ children, warehouseOnly = false }: PrivateRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-slate-50' role='status'>
        <div className='flex items-center gap-3 text-slate-600'>
          <span className='h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-emerald-600' />
          正在检查登录状态…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' replace state={{ from: location.pathname }} />;
  }

  if (warehouseOnly && !canManageWarehouse(user)) {
    return (
      <div className='rounded-2xl border border-slate-200 bg-white p-8 text-center'>
        <h2 className='text-xl font-bold text-slate-900'>无访问权限</h2>
        <p className='mt-3 text-sm text-slate-600'>库存操作仅限仓库管理员和系统管理员。借用样衣请提交借用申请。</p>
      </div>
    );
  }

  return <>{children}</>;
}
